var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquares2Dotted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web/Regular/17x17/squares.2.dotted",
    stroke: "currentColor",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.5,
    y: 6.5,
    width: 7,
    height: 7,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5v-.75a.75.75 0 01.75-.75H5",
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    d: "M6 3.5h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3.5h.75a.75.75 0 01.75.75V5h0",
    id: "Path-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    d: "M3.5 6v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9v.75c0 .414.336.75.75.75H5",
    id: "Path-6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquares2Dotted);
export default __webpack_public_path__ + "static/media/squares.2.dotted.52bd1c55.svg";
export { ForwardRef as ReactComponent };